import { render } from "./Evaluation.vue?vue&type=template&id=5d164edc&scoped=true"
import script from "./Evaluation.vue?vue&type=script&lang=js"
export * from "./Evaluation.vue?vue&type=script&lang=js"

import "./Evaluation.vue?vue&type=style&index=0&id=5d164edc&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d164edc"]])

export default __exports__